var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Search")]),_c('ul',_vm._l((_vm.params),function([key, value]){return _c('li',{key:key},[_vm._v(_vm._s(key)+": "+_vm._s(value))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }